<!--南海妇幼定制登陆页面-->
<template>
  <el-container>
    <el-header id="header" class="loginHeader">
      <div style="float:left">
        <img src="../assets/nhfy/logonnhfy.png"/>
      </div>
      <div class="title">
        <div class="title-main">佛山市南海区妇幼保健院</div>
        <div class="title-sub">Nanhai Maternity & Child Healthcare Hospital Of Foshan</div>
      </div>
    </el-header>
    <el-container v-bind:style="containerStyle">
      <div class="mainContainer">
        <el-container>
          <el-main>
            <img src="../assets/nhfy/bg.jpg"/>
          </el-main>
          <el-aside width="350px" class="login" style="overflow: hidden">
            <login v-on:loginSuccess="loginSuccess"></login>
          </el-aside>
        </el-container>
      </div>
    </el-container>
  </el-container>
</template>

<script>
  import Login from '@/components/Login.vue'
  import {keyCodes} from '../commons'

  export default {
    data() {
      return {
        containerHeight: 0
      }
    },
    props: {},
    computed: {
      containerStyle: function () {
        return {
          height: this.containerHeight + 'px',
          maxHeight: this.containerHeight + 'px',
          // border: '2px solid rgb(83,174,221)',
        }
      }
    },
    components: {
      Login
    },
    methods: {
      /**
       * 登陆成功后回调
       */
      loginSuccess(){
        const _this = this;
        _this.$store.dispatch('setLoginBy',keyCodes.LOGIN_BY_NHFY)
      }
    },
    watch: {},
    mounted(){
      const _this = this;
      _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      window.onresize = function windowResize() {
        _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      }
    }
  }
</script>

<style scoped lang="scss">
  .loginHeader{
    padding: 0px 60px 0px 60px;
    img {
      width: 120px;
      height: 120px
    }
  }
  .mainContainer {
    width: 1150px;
    margin: 100px auto;

  }

  .mainContainer .tile {
    font-size: 24px;
    font-weight: bold
  }

  .mainContainer main {
    padding: 0px;
    overflow: hidden;
  }

  .mainContainer img {
    width: 785px;
    height: 350px;
  }

  .login {
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    margin: 0px auto;
  }

  #footer {
    line-height: 40px;
    color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: rgb(83, 174, 221);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
  }
  .title {
    float: left;
    line-height: 40px;
    padding-left: 20px;

    div {
      height: 40px;
      text-align: left;
    }

    .title-main {
      font-size: 28px;
      font-weight: bold;
    }

    .title-sub {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/LoginNanHaiFuYou.vue